import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const CardSkeleton = () => {
  return (
    <div className="p-4 border rounded-lg shadow-sm w-full">
      {/* Title */}
      <Skeleton height={30} width={"70%"} style={{ marginBottom: "0.5rem" }} />
      {/* Subtitle */}
      <Skeleton height={20} width={"50%"} style={{ marginBottom: "1rem" }} />

      {/* Host Section */}
      <div className="flex items-center gap-2">
        <Skeleton circle={true} height={40} width={40} />
        <Skeleton height={20} width={"40%"} />
      </div>

      {/* Stats */}
      <div className="flex items-center gap-4 mt-2">
        <Skeleton width={20} height={20} />
        <Skeleton width={30} />
        <Skeleton width={20} height={20} />
        <Skeleton width={30} />
      </div>

      {/* Popular Listing */}
      <div className="mt-4 p-3 border rounded-md">
        <Skeleton height={20} width={"60%"} />
        <Skeleton height={20} width={"30%"} style={{ marginTop: "0.5rem" }} />
      </div>

      {/* Property Details */}
      <div className="flex justify-between mt-4">
        <Skeleton width={"20%"} height={20} />
        <Skeleton width={"20%"} height={20} />
        <Skeleton width={"20%"} height={20} />
        <Skeleton width={"20%"} height={20} />
      </div>
    </div>
  );
};

export default CardSkeleton;
